/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TenantSettingApiModel } from './tenantSettingApiModel';
import { AdminTenantSettingApiModel } from './adminTenantSettingApiModel';


export interface TenantAdminSettingsApiModel { 
    tenantSettings: Array<TenantSettingApiModel>;
    adminTenantSettings: Array<AdminTenantSettingApiModel>;
}

